export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Sign out": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["サインアウト"])}
    }
  })
}
